// components/dnd/board/status-type-board/status-type-board.component.jsx
import React, { useRef, useState, useEffect } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";

import TaskBoard from "../../board/task-board/task-board.component";
import RetroInput from "../../../retro/input/input.component";
import Box from "../../../retro/box/box.component";
import TaskSettings from "../../../task-settings/task-settings.component";

import { FaChevronDown } from "react-icons/fa";
import { BsGripHorizontal, BsChevronDown } from "react-icons/bs";

import {
  db,
  createNewTaskk,
  changeStatusTypeName,
  changePhaseName,
  toggleStatus,
} from "../../../../firebase/firebase.utils";

import "./status-type-board.styles.scss";

const StatusTypeBoard = ({
  currentSpaceId,
  currentStationId,
  status,
  tasks,
  index,
  stationTasksFL,
}) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const statusType = useSelector((state) => state.space.statusType);
  const [newTaskName, setNewTaskName] = useState("");
  const [inputName, setInputName] = useState("");
  const inputRef = useRef();
  const inputNameRef = useRef();

  const [multiSelectMode, setMultiSelectMode] = useState(false);
  const [multiSelectItems, setMultiSelectItems] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    createNewTaskk(
      currentSpaceId,
      currentStationId,
      status.id,
      newTaskName,
      currentUser.uid
    );
    inputRef.current.value = "";
    inputRef.current.blur();
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    // if (!statusType) return;
    changePhaseName(
      currentSpaceId,
      currentStationId,
      status.id,
      inputNameRef.current.value
    );
  };

  useEffect(() => {
    setInputName(status.name);
  }, [status.name]);

  // const [taken, setTaken] = useState([]);
  // useEffect(() => {
  //   //mounts
  //   const unsub = db
  //     .collection("space")
  //     .doc(currentSpaceId)
  //     .collection("stations")
  //     .doc(currentStationId)
  //     .collection("tasks")
  //     .where("startdate", "!=", null)
  //     .onSnapshot((querySnapshot) => {
  //       const array = querySnapshot.docs.map((doc) => {
  //         return {
  //           id: doc.id,
  //           title: doc.get("title"),
  //           start: doc.get("startdate").toDate(),
  //           end: doc.get("enddate").toDate(),
  //           allDay: doc.get("allDay"),
  //           duration: doc.get("duration"),
  //           phase: doc.get("phase"),
  //         };
  //       });
  //       // console.log("Current data in array: ", array);
  //       setTaken([...array]);
  //     });

  //   return () => {
  //     unsub();
  //   };
  // }, []);

  return (
    <Draggable draggableId={status.id} index={index}>
      {(provided) => (
        <div
          className="statusType"
          {...provided.draggableProps}
          ref={provided.innerRef}
        >
          <div className="st__header">
            <div className="st__arrow">
              <FaChevronDown
                style={{
                  color: status.fontColor,
                  transform: status.open ? "" : "rotate(-90deg)",
                  filter: status.open ? "grayScale(0%)" : "grayScale(100%)",
                  opacity: status.open ? "1" : "0.5",
                }}
                onClick={() =>
                  toggleStatus(currentSpaceId, currentStationId, status.id)
                }
              />
            </div>
            <div className="st__title">
              <form onSubmit={(e) => handleNameSubmit(e)}>
                <input
                  ref={inputNameRef}
                  value={inputName}
                  style={{
                    color: status.fontColor,
                    filter: status.open ? "grayScale(0%)" : "grayScale(100%)",
                    opacity: status.open ? "1" : "0.5",
                  }}
                  onChange={(e) => setInputName(e.target.value)}
                />
              </form>
            </div>
            <div className="st__menu">
              <div className="st__drag" {...provided.dragHandleProps}>
                <BsGripHorizontal />
              </div>
              <TaskSettings status={status} inputNameRef={inputNameRef} />
            </div>
          </div>
          <Box>
            <div className="st__content">
              <Droppable droppableId={status.id}>
                {(provided, snapshot) => {
                  const style = {
                    backgroundColor: snapshot.isDraggingOver
                      ? "rgba(0,0,0,0.05)"
                      : "",
                    borderRadius: "8px",
                    display: status.open ? "" : "none",
                  };
                  return (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <div className="st__taskList" style={style}>
                        {tasks?.map((task, index) => {
                          // if (task === undefined) return false;
                          return (
                            // <div
                            //   key={task.id}
                            //   task={task}
                            //   index={index}
                            //   status={task.phase}
                            // >
                            //   {task}
                            // </div>
                            <TaskBoard
                              key={task}
                              task={task}
                              index={index}
                              status={status}
                              multiSelectMode={multiSelectMode}
                              setMultiSelectMode={setMultiSelectMode}
                              multiSelectItems={multiSelectItems}
                              setMultiSelectItems={setMultiSelectItems}
                              stationTasksFL={stationTasksFL}
                            />
                          );
                        })}
                        {provided.placeholder}
                        <div className="st__newTask st__newTask-inside">
                          {status.open && (
                            <form
                              onSubmit={(e) => {
                                handleSubmit(e);
                              }}
                            >
                              <div
                                className="st__newTask-inputitem"
                                onChange={(e) => setNewTaskName(e.target.value)}
                              >
                                <RetroInput
                                  ref={inputRef}
                                  placeholder="Add Task"
                                />
                              </div>
                            </form>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }}
              </Droppable>
            </div>
          </Box>
        </div>
      )}
    </Draggable>
  );
};

export default StatusTypeBoard;
